import { useLazyQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { categorizePaymentFailure, getPaymentFailureAlertCopy } from '../utils/paymentFailure';
import { jsx as _jsx } from "react/jsx-runtime";
const showPaymentFailureAlert = category => {
  const {
    titleTranslationKey,
    textTranslationKey
  } = getPaymentFailureAlertCopy(category);
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleTranslationKey
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: textTranslationKey
    }),
    type: 'danger'
  });
};
const useHandlePaymentFailure = paymentResultQuery => useLazyQuery(paymentResultQuery, {
  fetchPolicy: 'no-cache',
  onCompleted: ({
    paymentResult
  }) => {
    showPaymentFailureAlert(categorizePaymentFailure(paymentResult.failureCode));
  },
  onError: error => {
    // A 404 means the payment attempt actually succeeded and there is no
    // failure to report; don't surface an error the buyer shouldn't see.
    if (error.networkError && 'status' in error.networkError && error.networkError.status === 404) {
      return;
    }
    showPaymentFailureAlert('OTHER');
  }
});
export default useHandlePaymentFailure;